import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const trTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Ad (küçük harf, özel karakter yok)',
    add: 'Ekle',
    allowedFileTypes: 'İzin Verilen Dosya Türleri',
    allowedFileTypesDescription:
      'İzin verilen dosya türlerini kısıtlayın (ör. resim/*, uygulama/pdf). Tüm türlere izin vermek için boş bırakın.',
    allowMultipleFiles: 'Birden Çok Dosyaya İzin Ver',
    amountInCents: 'Sent cinsinden tutar',
    basePrice: 'Taban Fiyat',
    bcc: 'BCC',
    brand: 'Marka',
    cc: 'CC',
    checkboxPlural: 'Onay Kutusu Alanları',
    checkboxSingular: 'Onay kutusu',
    checkedByDefault: 'Varsayılan olarak işaretlendi',
    chooseConfirmationType:
      'Formu gönderdikten sonra sayfada bir mesaj görüntülenip görüntülenmeyeceğini veya farklı bir sayfaya yönlendirilip yönlendirilmeyeceğini seçin.',
    condition: 'Durum',
    confirmationMessage: 'Onay Mesajı',
    confirmationType: 'Onay Türü',
    countryPlural: 'Ülke Alanları',
    countrySingular: 'Ülke',
    creditCard: 'Kredi Kartı',
    customURL: 'Özel URL',
    datePlural: 'Tarih Alanları',
    dateSingular: 'Tarih',
    defaultValue: 'Varsayılan Değer',
    divide: 'Böl',
    documentToLinkTo: 'Bağlantı verilecek belge',
    doesNotEqual: 'Eşit Değil',
    emailFrom: 'E-posta Gönderen',
    emailPlural: 'E-posta Alanları',
    emailsDescription:
      'Form gönderildiğinde özel e-postalar gönderin. Aynı e-postayı birden fazla alıcıya göndermek için virgülle ayrılmış listeleri kullanın. Bu formdaki bir değere referans vermek için, o alanın adını çift süslü parantez içine alın, yani {{firstName}}. Tüm verilerin çıktısını almak için {{*}} joker karakterini ve e-postada bunları bir HTML tablosu olarak biçimlendirmek için {{*:table}} joker karakterini kullanabilirsiniz.',
    emailSingular: 'E-posta',
    emailTo: 'E-posta Adresi',
    equals: 'Eşittir',
    field: 'Alan',
    fields: 'Alanlar',
    fieldWidth: 'Alan Genişliği (yüzde)',
    hasAnyValue: 'Herhangi Bir Değeri Vardır',
    internalLink: 'Dahili bağlantı',
    label: 'Etiket',
    maxFileSize: 'Maksimum Dosya Boyutu (bayt)',
    maxFileSizeDescription: 'Bayt cinsinden maksimum dosya boyutu. Sınırsız olarak boş bırakın.',
    message: 'Mesaj',
    messageDescription: 'Bu e-postada gönderilmesi gereken mesajı girin.',
    messagePlural: 'Mesaj Blokları',
    messageSingular: 'Mesaj',
    mimeType: 'MIME Türü',
    mimeTypePlural: 'MIME Türleri',
    mimeTypeSingular: 'MIME Türü',
    multiply: 'Çarp',
    numberPlural: 'Sayı Alanları',
    numberSingular: 'Sayı',
    optionPlural: 'Seçenekler',
    optionSingular: 'Seçenek',
    paymentFieldPlural: 'Ödeme Alanları',
    paymentFieldSingular: 'Ödeme',
    paymentProcessor: 'Ödeme İşlemcisi',
    paymentStatus: 'Durum',
    placeholder: 'Yer tutucu',
    priceConditions: 'Fiyat Koşulları',
    priceConditionsPlural: 'Fiyat Koşulları',
    priceConditionsSingular: 'Fiyat Durumu',
    radioOptions: 'Radyo Özellik Seçenekleri',
    radioPlural: 'Radyo Alanları',
    radioSingular: 'Radyo',
    redirect: 'Yönlendir',
    replyTo: 'Yanıtla',
    required: 'Gerekli',
    selectOptions: 'Seçenekleri Seçin',
    selectPlural: 'Alanları Seçin',
    selectSingular: 'Seç',
    statePlural: 'Durum Alanları',
    stateSingular: 'Eyalet',
    staticValue: 'Statik Değer',
    subject: 'Konu',
    submitButton: 'Düğme Etiketini Gönder',
    subtract: 'Çıkar',
    textareaPlural: 'Metin Alanı Alanları',
    textareaSingular: 'Metin alanı',
    textPlural: 'Metin Alanları',
    textSingular: 'Metin',
    title: 'Başlık',
    token: 'jeton',
    uploadCollection: 'Koleksiyonu Yükle',
    uploadCollectionDescription: 'Dosyaların hangi yükleme koleksiyonunda depolanacağını seçin',
    uploadFieldPlural: 'Alanları Yükle',
    uploadFieldSingular: 'Yükle',
    urlToRedirectTo: 'Yönlendirilecek URL',
    value: 'Değer',
    valueOfField: 'Alanın Değeri',
    valueType: 'Değer Türü',
  },
}

export const tr: PluginLanguage = {
  dateFNSKey: 'tr',
  translations: trTranslations,
}
